import React from 'react';

/** Renders a schema.org JSON-LD script without dangerouslySetInnerHTML. */
const JsonLd = ({ data }) => (
  <script type="application/ld+json">
    {JSON.stringify(data).replace(/</g, '\\u003c')}
  </script>
);

export default JsonLd;
